import { useEffect, useState } from 'react'

import { logErrorAsync } from '_lib/utility'
import { getTrendingTerms } from '_services/data-explorer'

export default function useTrendingTerms({ field, filters, entityType, lookback, language }) {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    async function getData() {
      setLoading(true)

      try {
        const data = await getTrendingTerms({
          field,
          filters,
          entityType: entityType || undefined,
          lookback,
          language,
        })
        setData(data)
      } catch (error) {
        logErrorAsync(error)
        toast.error(error.message)
      }

      setLoading(false)
    }

    if (field && lookback && language) {
      getData()
    }
  }, [filters, field, entityType, lookback, language])

  return [data, loading]
}
